export const environment = {
    production: false,
    apiUrl: 'https://api.pedeaqui.app',
    webHookUrl: 'https://webhook.pedeaqui.app',
    socketUrl: 'wss://webhook.pedeaqui.app',
    version: '1.1.2',

    //Development
    //apiUrl: 'https://devapi.pedeaqui.app',
    //webHookUrl: 'http://devwebhook.pedeaqui.app',
    //socketUrl: 'ws://devwebhook.pedeaqui.app',
};